/**
 * Default real-world distance nudges per modifier tier (divide by canvas scale
 * to get pixels). Shared by `useDrawPath` cursor nudging and HITLv2
 * frame-length editing.
 */
export const DistanceNudgeIncrements = {
	imperial: { coarse: 1, medium: 1 / 12, fine: 0.125 / 12 }, // 1ft, 1in, 1/8in (feet)
	metric: { coarse: 1000, medium: 100, fine: 10 }, // 1m, 100mm, 10mm
} as const;
